/** Builder › Memory: "Remember what people tell it" (ADR-0085). */
export default {
  en: {
    title: "Memory",
    remember: "Remember what people tell it",
    rememberHelp: "It keeps short notes about each person, such as their name and how they like answers, and uses them in later conversations.",
    consentNote: "It only remembers a person after they allow it in the Assistant. People can see and forget what it keeps at any time, under “What agents remember about me”.",
    reach: "Who can use what it remembers",
    reachAgent: "Only this agent",
    reachAgentHelp: "The notes stay with this agent, separately for each person.",
    reachUser: "The person's other agents too",
    reachUserHelp: "The notes go into the person's own memory. Other agents they allow to remember can use them.",
    keep: "Keep notes for",
    keep7: "1 week",
    keep30: "1 month",
    keep90: "3 months",
    keep365: "1 year",
    keepOther: "{{days}} days",
    tryNote: "Try it keeps no notes, because it changes nothing. To check memory, release the agent and use it in the Assistant.",
  },
  ar: {
    title: "الذاكرة",
    remember: "تذكّر ما يخبره به الناس",
    rememberHelp: "يحتفظ بملاحظات قصيرة عن كل شخص، مثل اسمه وطريقة الإجابة التي يفضّلها، ويستخدمها في المحادثات اللاحقة.",
    consentNote: "لا يتذكر شخصًا إلا بعد أن يسمح بذلك في المساعد. ويمكن للناس رؤية ما يحتفظ به ومحوه في أي وقت، من «ما يتذكره الوكلاء عني».",
    reach: "من يمكنه استخدام ما يتذكره",
    reachAgent: "هذا الوكيل فقط",
    reachAgentHelp: "تبقى الملاحظات لدى هذا الوكيل، منفصلة لكل شخص.",
    reachUser: "وكلاء الشخص الآخرون أيضًا",
    reachUserHelp: "تُحفظ الملاحظات في ذاكرة الشخص نفسه، ويمكن للوكلاء الآخرين الذين يسمح لهم بالتذكّر استخدامها.",
    keep: "الاحتفاظ بالملاحظات لمدة",
    keep7: "أسبوع واحد",
    keep30: "شهر واحد",
    keep90: "ثلاثة أشهر",
    keep365: "سنة واحدة",
    keepOther: "{{days}} يومًا",
    tryNote: "لا يحتفظ «جرّبه» بأي ملاحظات لأنه لا يغيّر شيئًا. للتحقق من الذاكرة، أطلق الوكيل واستخدمه في المساعد.",
  },
} as const;
